export default __webpack_public_path__ + "static/media/28.44bf515a.jpeg";